import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Table, Form, Modal } from "react-bootstrap";
import Pagination from "../pagination/Pagination";

const DownloadMaster = () => {
  const [agendas, setAgendas] = useState([]);
  const [years, setYears] = useState([]);
  const [newAgenda, setNewAgenda] = useState("");
  const [newYear, setNewYear] = useState("");
  const [editAgendaId, setEditAgendaId] = useState(null);
  const [editAgenda, setEditAgenda] = useState("");
  const [editYearId, setEditYearId] = useState(null);
  const [editYear, setEditYear] = useState("");
  const [showEditAgendaModal, setShowEditAgendaModal] = useState(false);
  const [showEditYearModal, setShowEditYearModal] = useState(false);
  const dist = sessionStorage.getItem("dist");

  const [showPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end });
  };

  useEffect(() => {
    fetchAgendas();
    fetchYears();
  }, []);

  // Fetch Agendas
  // const fetchAgendas = async () => {
  //   const res = await axios.get("https://lionsdirectoryapi.emedha.in/download/api/api/agendas");
  //   setAgendas(res.data);
  // };

  const fetchAgendas = async () => {
  const res = await axios.get(
    `https://lionsdirectoryapi.emedha.in/download/api/api/agendas?dist=${dist}`
  );
  setAgendas(res.data);
};


  // Fetch Years
  // const fetchYears = async () => {
  //   const res = await axios.get("https://lionsdirectoryapi.emedha.in/download/api/api/years");
  //   setYears(res.data);
  // };

  const fetchYears = async () => {
  const res = await axios.get(
    `https://lionsdirectoryapi.emedha.in/download/api/api/years?dist=${dist}`
  );
  setYears(res.data);
};


  // Add Agenda
  const handleAddAgenda = async () => {
    await axios.post("https://lionsdirectoryapi.emedha.in/download/api/api/agendas", {
      agenda_name: newAgenda,
        dist: dist,
    });
    setNewAgenda("");
    fetchAgendas();
  };

  // Add Year
  const handleAddYear = async () => {
    await axios.post("https://lionsdirectoryapi.emedha.in/download/api/api/years", {
      year: newYear,
        dist: dist,
    });
    setNewYear("");
    fetchYears();
  };

  // Edit Agenda
  const handleEditAgenda = async () => {
    await axios.put(`https://lionsdirectoryapi.emedha.in/download/api/api/agendas/${editAgendaId}`, {
      agenda_name: editAgenda,
        dist: dist,
    });
    setShowEditAgendaModal(false);
    fetchAgendas();
  };

  // Edit Year
  const handleEditYear = async () => {
    await axios.put(`https://lionsdirectoryapi.emedha.in/download/api/api/years/${editYearId}`, {
      year: editYear,
        dist: dist,
    });
    setShowEditYearModal(false);
    fetchYears();
  };

  // Delete Agenda
  const handleDeleteAgenda = async (id) => {
    await axios.delete(`https://lionsdirectoryapi.emedha.in/download/api/api/agendas/${id}`);
    fetchAgendas();
  };

  // Delete Year
  const handleDeleteYear = async (id) => {
    await axios.delete(`https://lionsdirectoryapi.emedha.in/download/api/api/years/${id}`);
    fetchYears();
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center" style={{ color: "orange" }}>
         Upload Master Management
      </h2>

      {/* Add Agenda and Add Year Forms side by side */}
      <div className="d-flex justify-content-center mb-3 mt-3">
        {/* Add Agenda */}
        <div className="d-flex flex-row align-items-center justify-content-center mx-3" style={{ width: '48%' }}>
          <Form.Control
            type="text"
            value={newAgenda}
            onChange={(e) => setNewAgenda(e.target.value)}
            placeholder="Enter Agenda"
            style={{ height: "38px" }}
          />
          <Button variant="warning" onClick={handleAddAgenda} className="mt-2">
            Add
          </Button>
        </div>

        {/* Add Year */}
             <div className="d-flex flex-row align-items-center justify-content-center mx-3" style={{ width: '48%' }}>
          <Form.Control
            type="number"
            value={newYear}
            onChange={(e) => setNewYear(e.target.value)}
            placeholder="Enter Year"
            style={{ height: "38px" }}
          />
          <Button variant="warning" onClick={handleAddYear} className="mt-2">
            Add
          </Button>
        </div>
      </div>

{/* Agendas List and Years List side by side */}
<div className="d-flex justify-content-between">
  {/* Agendas List */}
  <div className="flex-column" style={{ width: '48%' }}>
    <Table bordered hover>
      <thead className="bg-warning text-white">
        <tr>
          <th>#</th>
          <th>Agenda</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {agendas.slice(pagination.start, pagination.end).map((agenda, index) => (
          <tr key={agenda.id}>
            <td>{index + 1 + pagination.start}</td>
            <td>{agenda.agenda_name}</td>
            <td>
              <Button
                variant="primary"
                className="me-2"
                onClick={() => {
                  setEditAgendaId(agenda.id);
                  setEditAgenda(agenda.agenda_name);
                  setShowEditAgendaModal(true);
                }}
              >
                Edit
              </Button>
              <Button variant="danger" onClick={() => handleDeleteAgenda(agenda.id)}>
                Delete
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>

  {/* Years List */}
  <div className="flex-column" style={{ width: '48%' }}>
    <Table bordered hover>
      <thead className="bg-warning text-white">
        <tr>
          <th>#</th>
          <th>Year</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {years.slice(pagination.start, pagination.end).map((year, index) => (
          <tr key={year.id}>
            <td>{index + 1 + pagination.start}</td>
            <td>{year.year}</td>
            <td>
              <Button
                variant="primary"
                className="me-2"
                onClick={() => {
                  setEditYearId(year.id);
                  setEditYear(year.year);
                  setShowEditYearModal(true);
                }}
              >
                Edit
              </Button>
              <Button variant="danger" onClick={() => handleDeleteYear(year.id)}>
                Delete
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
</div>


      {/* Edit Agenda Modal */}
      <Modal show={showEditAgendaModal} onHide={() => setShowEditAgendaModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Agenda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={editAgenda}
            onChange={(e) => setEditAgenda(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditAgendaModal(false)}>
            Close
          </Button>
          <Button variant="warning" onClick={handleEditAgenda}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Year Modal */}
      <Modal show={showEditYearModal} onHide={() => setShowEditYearModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Year</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="number"
            value={editYear}
            onChange={(e) => setEditYear(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditYearModal(false)}>
            Close
          </Button>
          <Button variant="warning" onClick={handleEditYear}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Pagination */}
      <Pagination
        page={showPerPage}
        onChangePagination={onChangePagination}
        total={agendas.length + years.length}
      />
    </div>
  );
};

export default DownloadMaster;
